import type { PolicyRepositoryT } from "../../domain/ports/policy.repository";
import type { PolicyApiT, PolicyMapperT } from "../types/policy.types";

import { extractErrorMessage } from "../../../utils/extractErrorMessage";

type PolicyRepositoryParamsT = {
  policyApi: PolicyApiT;
  policyMapper: PolicyMapperT;
};

export const createPolicyRepository = ({
  policyApi,
  policyMapper,
}: PolicyRepositoryParamsT): PolicyRepositoryT => ({
  updatePermissionPolicy: async (data, colaboraInstanceId, policyId) => {
    try {
      const dto = policyMapper.toPermissionPolicyDTO(data);
      
      const response = await policyApi.update(
        dto,
        colaboraInstanceId,
        policyId,
      );
      
      if (response.status !== 200 && response.status !== 201) {
        throw new Error(
          "Ocurrió un error al actualizar la política del permiso",
        );
      }

      return policyMapper.updatePolicyToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al actualizar la política del permiso",
      );
      
      throw new Error(message);
    }
  },
  updateVacationPolicy: async (data, colaboraInstanceId, policyId) => {
    try {
      const dto = policyMapper.toVacationPolicyDTO(data);
      
      const response = await policyApi.update(
        dto,
        colaboraInstanceId,
        policyId,
      );
      
      if (response.status !== 200 && response.status !== 201) {
        throw new Error(
          "Ocurrió un error al actualizar la política de vacaciones",
        );
      }
      
      return policyMapper.updatePolicyToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al actualizar la política de vacaciones",
      );

      throw new Error(message);
    }
  },
});
